__turbopack_context__.v({
  "back": "WBdhfG_back",
  "body": "WBdhfG_body",
  "ctas": "WBdhfG_ctas",
  "disclaimer": "WBdhfG_disclaimer",
  "idmeButton": "WBdhfG_idmeButton",
  "option": "WBdhfG_option",
  "optionDescription": "WBdhfG_optionDescription",
  "optionTitle": "WBdhfG_optionTitle",
  "options": "WBdhfG_options",
  "root": "WBdhfG_root",
  "title": "WBdhfG_title",
});
